export enum CustomAtsIntegrationType {
  Comeet = 'COMEET',
  Greenhouse = 'GREENHOUSE',
  Ashby = 'ASHBY',
  ZohoRecruit = 'ZOHO_RECRUIT'
}

export const OAUTH_ATS_LIST: CustomAtsIntegrationType[] = [CustomAtsIntegrationType.ZohoRecruit];
